import * as yup from 'yup';

export const yupsRequiredString = () => yup.string().required('Required');
